export default __webpack_public_path__ + "static/media/bandwidth-QoS.9bfc869d.png";